export const EXPORT_TABLE_TITLE = 'Журнал сессий';
